module.exports = __webpack_public_path__ + "img/T6-A-rc_2.369a8557.png";